// extracted by mini-css-extract-plugin
export default {"noPadding":"GrantPermissionPage_noPadding__kyczB","mobileButtonPadding":"GrantPermissionPage_mobileButtonPadding__uLk2-"};